import React, { Component } from "react";
import { renderRoutes } from "react-router-config";
import { Helmet } from "react-helmet";
// import MobileDetect from "mobile-detect";
// import { switchMobile } from "../actions/device";
import { withRedux } from "../hoc";

// const md = new MobileDetect(window.navigator.userAgent);

const mapStateToProps = state => {
  return {
    currentLang: state.language.currentActive
  };
};
const actionToProps = {
  // switchMobile
};

class Root extends Component {
  // componentDidMount() {
  //   console.log('md.os()', md.os());
  //   const isMobile = md.os() === 'iOS' || md.os() === 'Android';
  //   this.props.actions.switchMobile(isMobile);
  // }

  render() {
    const { route, currentLang } = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <html lang={currentLang} amp />
          <meta charSet="utf-8" />
          <title>Laguna</title>
          <link rel="canonical" href={window.location.href} />
        </Helmet>
        <div className="root-content">{renderRoutes(route.routes)}</div>
      </React.Fragment>
    );
  }
}

export default withRedux(mapStateToProps, actionToProps)(Root);



// WEBPACK FOOTER //
// ./src/pages/Root.js